module.exports = __webpack_public_path__ + "static/restaurant1-27264b3f9f135f067ffcf89b743b7e65.png";